import { getCookieByName } from '../../../../lib/getCookieByName';
import type { Item } from './types';

export const getMatchingRoutes = (items: Item[]): string[] => {
  const matches: string[] = [];
  items
    .filter(i => !i.newTab)
    .forEach(i => {
      if (i.activeUrl) {
        if (Array.isArray(i.activeUrl)) {
          matches.push(...i.activeUrl);
        } else {
          matches.push(i.activeUrl);
        }
      } else {
        matches.push(i.url);
      }
    });
  return matches;
};

export const EXPIRATION_DATE_DISABLE_NEW_NAVIGATION = new Date('2025-06-01T00:00:00.000Z');

export const toggleNewNavigation = (shouldDisable: boolean) => {
  const existingCookie = getCookieByName('new_navigation_feature_disabled');
  let expiryDate: Date | undefined;

  if (existingCookie) {
    try {
      const { expiry } = JSON.parse(existingCookie);
      expiryDate = new Date(expiry);
    } catch (error) {
      console.error('Error parsing existing cookie:', error);
    }
  }

  if (!expiryDate || expiryDate < new Date()) {
    expiryDate = EXPIRATION_DATE_DISABLE_NEW_NAVIGATION;
  }

  const expires = `expires=${expiryDate.toUTCString()}`;

  const cookieValue = JSON.stringify({
    value: shouldDisable ? 'true' : 'false',
    expiry: expiryDate.toISOString(),
  });

  if (shouldDisable) {
    document.cookie = `new_navigation_feature_disabled=${encodeURIComponent(cookieValue)}; ${expires}; path=/; Secure; SameSite=Lax`;
  } else {
    document.cookie =
      'new_navigation_feature_disabled=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }

  window.location.reload();
};
